import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";

function Block5() {

    return (
            <section className="cta-home21-1 bgc-home21 homepage layout-pt-120 layout-pb-40">
                <div className="auto-container">
                    <div className="row align-items-center">

                        <div className="content-column col-md-6 col-lg-5 offset-lg-1 order-2">
                            <div className="inner-column wow fadeInRight pt-0">
                                <div className="sec-title mb-4">
                                    <h2 className="homepage mb35">Un espace qui contribue <span>à votre politique handicap</span></h2>
                                    <div className="text homepage left">Avec la Hotline Talents Handicap, vous contribuez concrètement
                                        à apporter à vos collaborateur un environnement de travail inclusif, favorable
                                        pour :
                                    </div>
                                    <ul className="list-style-two at-home19 homepage mt20">
                                        <li>la santé au travail et la prévention des risques</li>
                                        <li>la qualité de vie et des conditions de travail (QVCT)</li>
                                        <li>le maintien dans l’emploi de vos collaborateurs en situation de handicap</li>
                                    </ul>
                                    <div className="text homepage left">En offrant la Hotline Talents Handicap à vos collaborateurs,
                                        vous les encouragez à s’informer de manière confidentielle et anonyme, pour
                                        révéler leur situation de handicap le cas échéant, et pour bénéficier de
                                        conditions de travail adaptées, favorables à leur santé et à leur emploi.
                                    </div>
                                </div>
                                <ContactModal textButton="Contactez-nous et disposez de votre
                                    Hotline Handicap" showText={false} small="small" linkPageContact={false} iframe={false} couleur={false} formModal={true}/>
                            </div>
                        </div>


                        <div className="image-column col-md-6 col-lg-6 mb-4 mb-lg-0">
                            <figure className="image-box wow fadeInLeft mx-0">
                                <img src="/images/resource/collage.png" alt="politique-handicap" className="homepage"/>
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default Block5;
